import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || ''

export const publicClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
})

export interface JumppageTexts {
  title: string
  subtitle: string
  hint_text: string
}

export interface SchoolDesignPublic {
  theme: 'light' | 'dark'
  logo_position: 'center' | 'left' | 'none'
  show_school_name: boolean
  logo_data: string | null
  logo_url: string | null
  primary_color: string
  bg_color: string
  text_color: string
  muted_color: string
  button_bg_color: string
  button_text_color: string
  button_hover_color: string
  border_color: string
}

export interface JumppageResponse {
  school_id: string
  slug: string
  enabled: boolean
  texts: JumppageTexts
  design: SchoolDesignPublic
  school_name: string
}

export const getPublicJumppage = async (slug: string): Promise<JumppageResponse> => {
  const { data } = await publicClient.get<JumppageResponse>(`/api/v1/jumppage/${slug}`)
  return data
}
